﻿import { defineComponent } from 'vue';

import { client } from "../../../booking_engine/objects/v1_2/Booking_Details/client";

export default defineComponent({
    components: {
    },
    props: {
        pax: client,
        index: Number
    },
    methods: {
        Lead_Passenger(): boolean {
            return this.index == 0;
        },
        Initials(): string {
            const first = (this.pax?.first_name ?? "").trim().charAt(0);
            const last = (this.pax?.family_name ?? "").trim().charAt(0);
            return (first + last).toUpperCase() || "?";
        }
    },
    mounted() {
    }
});